export default {
    change: 'Change'
}
